export default {
    change: 'Change'
}
